// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-select/~/rc-animate/lib/index.js
 ** module id = 359
 ** module chunks = 0
 **/